<template>
    <div>
        <div v-if="offerChoices">

            <div class="box p-sm" v-for="(choice, index) in offerChoices" :key="index" v-if="choice.choices[0]">
                <div class="columns is-size-5">
                    <div class="column">
                        <div>
                            <span class="is-size-6 has-text-weight-bold" >{{ choice.choices[0].offer.name.fr }}</span>
                        </div>
                        <div v-if="choice.choices[0].session">
                            <div class="is-size-7">{{ choice.choices[0].session.campus.name }}</div>
                            <div class="is-size-7">
                                <i>{{ choice.choices[0].session.begin | moment }}</i> au <i>{{ choice.choices[0].session.end | moment }}</i>
                            </div>
                        </div>
                    </div>

                    <div class="column is-4 has-text-right">
                        <span v-if="choice.choices">
                            <strong><i>{{ offerFees(choice.choices) }}</i></strong>
                        </span>
                    </div>

                </div>

                <div>
                    <div>
                        <span class="is-size-6 has-text-weight-bold" >{{ $t('shop.offers.child_registered') }}:</span>
                    </div>
                    <span v-if="hasCandidates" v-for="candidate in activeCandidates">
                        <span class="button m-sm" v-if="isRegistered(candidate, choice.choices)">
                             {{ candidate.first_name }}
                        </span>
                    </span>
                </div>

                </div>
        </div>
    </div>
</template>

<script>

    import {mapActions, mapGetters} from 'vuex'

    export default {
        data () {
            return {
            }
        },
        props: {
            order: { type: Object }
        },
        computed: {
            ...mapGetters(
                'auth', [
                    'getAccount'
                ]
            ),
            ...mapGetters(
                'orders', [
                    'candidateOfferChoices',
                    'checkoutStatus'
                ]
            ),
            ...mapGetters('candidate', [
                'hasCandidates',
                'activeCandidates',
            ]),
            ...mapGetters(
                'organization', [
                    'getSchoolBySlug'
                ]
            ),
            offerChoices() {
                return this.candidateOfferChoices(this.order.order_status, this.order)
            },
            school() {
                return this.getSchoolBySlug(this.$route.params.school)
            }

        },
        methods: {
            isRegistered (candidate, choices) {
                return choices.some(item => item.candidate_id === candidate.id)
            },
            offerFees (choices) {
                const school = this.getSchoolBySlug(this.$route.params.school)
                if (school) {
                    /*return prices.filter(function (price) {
                        return price.school_id === school.id
                    }).map(price => price.price+' '+price.currency)[0];*/

                    let price = null
                    choices.map(function (choice) {
                        price += choice.price
                    })

                    if (price) {
                        return price+' '+school.fees_currency
                    }
                }
            }
        },
        filters: {
            moment: function (date) {
                return moment(date).format('LL')
            }
        }
    }
</script>

<style scoped>

</style>
